import { LogLevel, Logger, LogFn } from './types'

/**
 * Ordered by strictness (desc)
 */
const LOG_LEVELS: LogLevel[] = ['none', 'error', 'warning', 'debug']

const ERROR_INDEX = LOG_LEVELS.indexOf('error')
const WARNING_INDEX = LOG_LEVELS.indexOf('warning')
const DEBUG_INDEX = LOG_LEVELS.indexOf('debug')

const log: LogFn = (message, ...optionalParams) =>
  console.log(message, optionalParams)
const noop: LogFn = () => undefined

export const createLogger = (logLevel?: LogLevel): Logger => {
  const { debug, warning, error } = getLoggerFlags(logLevel)
  return {
    debug: debug ? log : noop,
    warning: warning ? log : noop,
    error: error ? log : noop
  }
}

const getLoggerFlags = (logLevel: LogLevel = 'none') => {
  const logLevelIndex = LOG_LEVELS.indexOf(logLevel)
  return {
    debug: logLevelIndex >= DEBUG_INDEX,
    warning: logLevelIndex >= WARNING_INDEX,
    error: logLevelIndex >= ERROR_INDEX
  }
}
